var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBoilerManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fzc8x0dtsa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.819608 0 0 0 0 0.200000 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 2c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1V3c0-.552.448-1 1-1h14zm-3 11H8c-.552 0-1 .448-1 1v4c0 .552.448 1 1 1h8c.552 0 1-.448 1-1v-4c0-.552-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 7,
    y: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5H15.5V17.5H8.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBoilerManagement);
export default __webpack_public_path__ + "static/media/icons-boiler-management.3d3df96b52fad0473a409903acc5dea3.svg";
export { ForwardRef as ReactComponent };